import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type ModelRef } from 'vue'
import SelectButton from 'primevue/selectbutton'
import { filterTimeOptions, type TimeOptionLabel } from '@/utils/time'

interface Props {
    disabled: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarTime',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {
    default: filterTimeOptions[2],
},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['filterChanged'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const timeOption: ModelRef<TimeOptionLabel> = _useModel(__props, "modelValue")
const ptSelectButton = {
    root: { class: 'filter-select-button' },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectButton), {
    modelValue: timeOption.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeOption).value = $event)),
    options: _unref(filterTimeOptions),
    disabled: _ctx.disabled,
    "allow-empty": false,
    "option-label": "label",
    pt: ptSelectButton,
    onChange: _cache[1] || (_cache[1] = (event) => emit('filterChanged', event.value))
  }, null, 8, ["modelValue", "options", "disabled"]))
}
}

})